/* ============
 * Getters for the auth module
 * ============
 *
 * The getters that are available on the
 * auth module.
 */

import helper from 'Resources/util/helper';

export const getByKey = (key) => {

    let data = localStorage.getItem(key);

    if (data) {
        return helper.getWithExpiry(data, key);
    }

    return null;

};

export default {
    getList: state => {
        return (url, params) => {

            const key = state.generate_key(url, params);
    
            return getByKey(key);

        };
    }
};
